/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, TOBI){
	const a = 'is-active';
	const v = 'is-visible';
	const $jsNewsList = $('.js-newsYear-list');
	const $map = location.pathname;
	const $dir = $map.split('/')[1];
	let oldestY = 2013;
	let latestY; // 仮
	let urlHead = '/ir/ir_news/';

	// <共通>JSON取得----------------------------------------------
	const getJSONlatestYear = (_cat) => {
		return $.getJSON(`/ajax/${_cat}/latest_news_year.json`);
	};
	//------------------------------------------------------------

	getJSONlatestYear($dir).done((data) => {
		// 最新年号取得
		latestY = Number(data.rt_bn_news_list[0].rt_latest_year);

		// プレスリリースの場合：最新年から6年文のニュースを公開
		if($dir === 'press_release') {
			oldestY = latestY - 5;
			urlHead = '/press_release/';
		}

		// /ir/ir_news/と/press_release/から最新年号へリダイレクト
		if($map === '/ir/ir_news/' || $map === '/ir/ir_news/index.html' ||
		 $map === '/press_release/' || $map === '/press_release/index.html') {
		 	$('#main_second').css('opacity', 0);
			location.href = urlHead + latestY + '.html';
		}

		// サイドメニュー年号リスト生成
		for(let i=oldestY; i<latestY+1; i++) {
			$jsNewsList.prepend(`<li><a href="${urlHead}${i}.html">${i}年</a></li>`);
		}

	});

})(window.jQuery, window.TOBI);
